import { render, staticRenderFns } from "./vms-device-management.vue?vue&type=template&id=41cb34db&"
import script from "./vms-device-management.vue?vue&type=script&lang=js&"
export * from "./vms-device-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports